module.exports = __webpack_public_path__ + "static/media/laurastromboni.8f8a0b33.svg";